// DS: i4.37
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import IconWrap from '../../IconWrap';
const Sale = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _object_spread_props(_object_spread({}, props), {
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.6663 5.3334V16L24.533 16V18.1334L22.3997 18.1334V20.2667L20.2663 20.2667V22.4L18.133 22.4V24.5334L15.9997 24.5334V26.6667H13.8663L13.8663 24.5334H11.733L11.733 22.4H9.59967L9.59968 20.2667H7.46634L7.46634 18.1334H5.33301V16H7.46634L7.46634 13.8667H9.59968L9.59968 11.7334H11.733L11.733 9.60004H13.8663L13.8663 7.46671H15.9997L15.9997 5.33337L26.6663 5.3334ZM20.2663 8.53338L23.4663 8.53337V11.7334L20.2663 11.7334L20.2663 8.53338Z"
    })));
Sale.displayName = 'Sale';
export default Sale;
